import { createStyles, makeStyles } from '@mui/styles';

export default makeStyles(() =>
  createStyles({
    button: {
      padding: 0,
    },
  }),
);
